module.exports = __webpack_public_path__ + "static/assets/daecb051770086623b3edd6499405ef1.png";